<template>
    <div class="width100" v-if="cruise">
        <h3>Highlights van deze cruise</h3>
        <p
            v-for="(highlight, index) in getRandomHighlights"
            :key="'RandomHighlight' + index"
        >
            <font-awesome-icon
                icon="check-circle"
                class="marginright10 icongreen"
            />
            {{ highlight }}
        </p>
    </div>
</template>

<script>
export default {
    name: 'CruiseHighlights',
    props: {
        cruise: Object,
        randomHighlights: Array,
    },
    computed: {
        getRandomHighlights: function() {
            let randomHighlights = []

            let cruiseTotal = this.cruise.schip_usps.length
            let random = Math.floor(Math.random() * cruiseTotal)
            randomHighlights.push(this.cruise.schip_usps[random])
            if (random > 1) {
                randomHighlights.push(this.cruise.schip_usps[random - 1])
            } else {
                randomHighlights.push(this.cruise.schip_usps[random + 1])
            }

            cruiseTotal = this.cruise.rederij_usps.length
            random = Math.floor(Math.random() * cruiseTotal)
            randomHighlights.push(this.cruise.rederij_usps[random])
            if (random > 1) {
                randomHighlights.push(this.cruise.rederij_usps[random - 1])
            } else {
                randomHighlights.push(this.cruise.rederij_usps[random + 1])
            }
            let maxHighlightsCruise = 7
            let i = 2
            let itinLength =
                Object.values(this.cruise.itinerary.days).length - 1
            while (i <= itinLength) {
                if (this.cruise.itinerary.days[i].highlight1) {
                    if (
                        !randomHighlights.includes(
                            this.cruise.itinerary.days[i].highlight1 +
                                ' in ' +
                                this.cruise.itinerary.days[i].haven_naam
                        )
                    ) {
                        randomHighlights.push(
                            this.cruise.itinerary.days[i].highlight1 +
                                ' in ' +
                                this.cruise.itinerary.days[i].haven_naam
                        )
                    }
                }
                if (randomHighlights.length > maxHighlightsCruise) {
                    break
                }
                if (this.cruise.itinerary.days[i].highlight2) {
                    if (
                        !randomHighlights.includes(
                            this.cruise.itinerary.days[i].highlight2 +
                                ' in ' +
                                this.cruise.itinerary.days[i].haven_naam
                        )
                    ) {
                        randomHighlights.push(
                            this.cruise.itinerary.days[i].highlight2 +
                                ' in ' +
                                this.cruise.itinerary.days[i].haven_naam
                        )
                    }
                }
                if (randomHighlights.length > maxHighlightsCruise) {
                    break
                }
                i = i + 1
            }

            return randomHighlights
        },
    },
}
</script>

<style scoped>
.icongreen {
    color: #8bc34a;
    font-weight: bold;
    font-size: 14px;
}
@media screen and (min-width: 1025px) {
    .width100 {
        width: 320px;
        margin-left: 30px;
    }
    h3 {
        margin: 0;
    }
    p {
        margin: 6px 0;
    }
}
</style>
